import React from 'react';
import { connect } from 'react-redux';
import ButtonGroup from 'components/shared/button-group/button-group';
import ContentItem from './content-item';
import TabWrapper from 'components/shared/profile-tabs/tab-wrapper';
import _ from 'underscore';
import {
  changeVideosSort,
  fetchAllContentItems,
  openDialog,
} from 'common/actions';
import * as DialogTypes from 'common/dialog-types';
import './author-videos-tab.scss';

const defaultSort = {value: 'views', label: 'Most Views'};

class AuthorVideosTab extends React.Component {
  static propTypes = {
    author: React.PropTypes.shape({
      hideDisplayAds: React.PropTypes.bool.isRequired,
    }),
    dispatch: React.PropTypes.func,
    videos: React.PropTypes.shape({
      contentItems: React.PropTypes.arrayOf(React.PropTypes.object),
      sort: React.PropTypes.string,
      isComplete: React.PropTypes.bool.isRequired,
    }).isRequired,
    isMobile: React.PropTypes.bool.isRequired,
  }

  constructor() {
    super();
    this.getContent = this.getContent.bind(this);
    this.onChangeSort = this.onChangeSort.bind(this);
    this.onShareVideoClick = this.onShareVideoClick.bind(this);
  }

  componentDidMount() {
    const videos = this.props.videos;
    if (!videos.isComplete) {
      let lastContentId = null;
      if (videos.contentItems && videos.contentItems.length) {
        lastContentId = videos.contentItems[videos.contentItems.length - 1].id;
      }
      this.props.dispatch(fetchAllContentItems(lastContentId));
    }
  }

  onChangeSort(option) {
    this.props.dispatch(changeVideosSort(option));
  }

  onShareVideoClick(id, title, url, tweetText) {
    this.props.dispatch(openDialog(
      DialogTypes.SHARE_VIDEO_DIALOG,
      {
        id,
        title,
        tweetText,
        url: url,
        type: 'VideoContent',
      }));
  }

  getContent() {
    let contentItems = this.props.videos.contentItems;
    const sort = this.props.videos.sort || defaultSort.value;

    if (sort === 'recent') {
      contentItems = _.sortBy(contentItems, contentItem => {
        return contentItem.unixTime * -1;
      });
    } else if (sort === 'views') {
      contentItems = _.sortBy(contentItems, contentItem => {
        return contentItem.views * -1;
      });
    }

    return _.map(contentItems, contentItem => {
      return (
        <ContentItem key={contentItem.id + '-content-item'}
          onShareVideoClick={this.onShareVideoClick}
          {...contentItem}/>
      );
    });
  }

  getSort() {
    if (!this.props.videos.sort) {
      return defaultSort;
    }
    switch (this.props.videos.sort) {
    case 'recent':
      return {
        value: this.props.videos.sort,
        label: 'Newest',
      };
    case 'views':
      return {
        value: this.props.videos.sort,
        label: 'Most Views',
      };
    default:
      return defaultSort;
    }
  }

  render() {
    const sortBy = this.getSort().value;

    if (this.props.videos.contentItems.length === 0) {
      return (
        <TabWrapper>
          {undefined}
        </TabWrapper>
      );
    }

    return (
      <TabWrapper>
        <div className="tab-panel highlights compact-margin">
          <div className="video-controls">
            <div className="controls-left">
              <ButtonGroup buttons={[
                {
                  label: 'Most Views',
                  value: 'views',
                  isSelected: sortBy === 'views',
                },
                {
                  label: 'Newest',
                  value: 'recent',
                  isSelected: sortBy === 'recent',
                },
              ]} onButtonPressed={this.onChangeSort}/>
            </div>
          </div>

          <div className="videos-list">
            {this.getContent()}
          </div>
        </div>
      </TabWrapper>
    );
  }
}

function select(state) {
  return state;
}

export default connect(select)(AuthorVideosTab);
